import React from "react";
import BannerImage from "../assets/images/banner-1.png";
import aboutImage from "../assets/images/about1.png";
import associationImage from "../assets/images/association.png";
import icon1 from "../assets/icons/iconR1.png";
import icon2 from "../assets/icons/iconR2.png";
import icon3 from "../assets/icons/iconR3.png";
import { Link } from "react-router-dom";
const AboutUs = () => {
  return (
    <>
      <section className="about-us-banner">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div class="about-us-title">
                <h1 className="about-text">About Curenza</h1>
                <h2>Omshakthi Monitoring Service Private Limited</h2>
                <p>Innovating Facility Management for Smarter Spaces</p>
              </div>
            </div>
          </div>
        </div>

        <div className="container mt-5">
          <div className="row">
            <div className="col-4"></div>
            <div className="col-lg-8 col-md-12">
              <div className="about-us-image">
                <img src={BannerImage} alt="" />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="about-us-details">
        <div className="container">
          <div className="row row-gap-4 flex-column-reverse flex-lg-row">
            <div className="col-12 col-lg-6">
              <div className="details-image">
                <img src={aboutImage} alt="" />
              </div>
            </div>
            <div className="col-12 col-lg-6 d-flex justify-content-center align-items-center">
              <div className="details-text">
                <h2>
                  <span className="highlight">
                    Innovating Facility Management{" "}
                  </span>
                  for Smarter Spaces
                </h2>
                <p>
                  At Curenza(Omshakthi Monitoring Service Private Limited), we
                  believe in the power of technology to transform everyday
                  facility management into a seamless and efficient experience.
                  From residential complexes to commercial spaces, our focus is
                  on developing cutting-edge software solutions that streamline
                  operations, enhance service coordination, and improve overall
                  efficiency.
                  <h2 className="mt-5">
                    <span className="highlight">What We</span> Do
                  </h2>
                  <p>
                    Curenza(Omshakthi Monitoring Service Private Limited)
                    specializes in Facility Management Software (FMS) designed
                    to automate and optimize maintenance, vendor coordination,
                    and issue resolution. With a user-centric approach, we
                    create smart digital ecosystems that connect property
                    owners, management teams, and service providers through one
                    powerful platform.
                  </p>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="facility-section">
        <div className="container">
          <h2 className="text-center">Curenza & Facility Management</h2>
          <p className="text-center">
            In today’s fast-paced world, facility management is more than just
            maintaining a space—it’s about delivering efficiency, security, and
            convenience. Our software solutions cater to:
          </p>
          <div className="row mt-4 d-flex justify-content-center row-gap-4">
            <div className="col-12 col-md-6 col-lg-4 col-xl-3">
              <div className="facility-information">
                <div className="facility-image">
                  <img src={icon1} alt="" />
                </div>
                <h5 className="mt-4">Residential Societies & RWAs</h5>
                <p className="facility-text mt-3 ">
                  Ensuring seamless coordination between residents and service
                  vendors.Ensuring seamless coordination between residents and
                  service vendors.
                </p>
              </div>
            </div>
            <div className="col-12 col-md-6 col-lg-4 col-xl-3">
              <div className="facility-information">
                <div className="facility-image">
                  <img src={icon2} alt="" />
                </div>
                <h5 className="mt-4">Commercial Properties</h5>
                <p className="facility-text mt-3 ">
                  Automating maintenance and vendor management to reduce
                  operational costs.Automating maintenance and vendor management
                  to reduce operational costs.
                </p>
              </div>
            </div>
            <div className="col-12 col-md-6 col-lg-4 col-xl-3">
              <div className="facility-information">
                <div className="facility-image">
                  <img src={icon3} alt="" />
                </div>
                <h5 className="mt-4">Service Providers</h5>
                <p className="facility-text mt-3 ">
                  Helping vendors streamline workflows, improve response times,
                  and enhance service delivery.
                </p>
              </div>
            </div>
            <h4 className="facility-sub-text text-center mt-5">
              With AI-powered automation, data-driven analytics, and cloud-based
              infrastructure, Curenza’s facility management software ensures a
              future-ready approach to property maintenance and management.
            </h4>
          </div>
        </div>
      </section>

      <section className="our-association">
        <div className="container">
          <div className="row row-gap-4">
            <div className="col-12 col-lg-6">
              <div className="association-image">
                <img src={associationImage} alt="" />
              </div>
            </div>
            <div className="col-12 col-lg-6 d-flex justify-content-center align-items-center">
              <div className="association-text">
                <h2>
                  <span className="highlight">Our Association with </span>{" "}
                  Facility Management
                </h2>
                <p>
                  Curenza(Omshakthi Monitoring Service Private Limited) is at
                  the heart of creating next-gen facility management software,
                  ensuring seamless communication between property managers,
                  residents, and service providers. Whether it's issue tracking,
                  vendor management, or maintenance scheduling, Curenza’s
                  technology is built to simplify complexities and enhance
                  efficiency.
                </p>
                <h2 className="mt-5">
                  <span className="highlight">Who We </span> Are
                </h2>
                <p>
                  We are a team of dedicated innovators, developers, and
                  industry experts who are passionate about creating scalable,
                  reliable, and user-friendly solutions for facility management.
                  Our combined expertise in technology, real estate, and service
                  management allows us to craft tailor-made digital solutions
                  that redefine the way facilities are managed.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="why-choose-us">
        <div className="container">
          <h2 className="text-center">Why Choose Curenza?</h2>
          <div className="row mt-4 row-gap-4">
            <div className="col-12 col-md-6 col-lg-4 col-xl-3">
              <div className="why-choose-us-details">
                <h5 className="choose-us-heading">
                  End-to-End Facility Management Solutions
                </h5>
                <p>
                  Designed to automate and optimize all aspects of property
                  management.
                </p>
              </div>
            </div>
            <div className="col-12 col-md-6 col-lg-4 col-xl-3">
              <div className="why-choose-us-details">
                <h5 className="choose-us-heading">Smart Integrations</h5>
                <p>
                  Cloud-based, AI-powered, and scalable to adapt to businesses
                  of all sizes.
                </p>
              </div>
            </div>
            <div className="col-12 col-md-6 col-lg-4 col-xl-3">
              <div className="why-choose-us-details">
                <h5 className="choose-us-heading">People-First Approach</h5>
                <p>Built for ease of use, transparency, and efficiency.</p>
              </div>
            </div>
            <div className="col-12 col-md-6 col-lg-4 col-xl-3">
              <div className="why-choose-us-details">
                <h5 className="choose-us-heading">Expert-Led Innovation</h5>
                <p>
                  Developed by a team that understands both technology and
                  property management needs.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="call-to-action">
        <div className="container">
          <div className="row d-flex justify-content-center">
            <div className="col-12 col-xl-9">
              <div className="call-to-action-content px-4 py-5 d-flex justify-content-center align-items-center">
                <h4>
                  Join us in revolutionizing facility management with Curenza.
                </h4>
                <Link to="/vendor-register" className="cta-btn">
                  Join us Today
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default AboutUs;
